module.exports = __webpack_public_path__ + "img/malinovo.e9c0bde9.png";